// Phase 8c — rate change-log read schemas (operator-only).
import { z } from 'zod';
import { RateIsoDateSchema } from './_shared.schema.js';
export const AdminRateChangeLogTableSchema = z.enum([
    'rate_card',
    'rate_modifier',
    'facility_bill_rate_override',
    'caregiver_pay_rate_override',
]);
export const AdminRateChangeLogEntrySchema = z.object({
    id: z.string().uuid(),
    actorUserId: z.string().uuid(),
    actorEmail: z.string(),
    ts: z.string(),
    tableName: AdminRateChangeLogTableSchema,
    recordKey: z.string(),
    oldValue: z.unknown().nullable(),
    newValue: z.unknown().nullable(),
    reason: z.string(),
    appliedEffectiveFrom: RateIsoDateSchema,
});
export const AdminRateChangeLogListQuerySchema = z.object({
    tableName: AdminRateChangeLogTableSchema.optional(),
    recordKey: z.string().optional(),
    actorUserId: z.string().uuid().optional(),
    page: z.coerce.number().int().positive().default(1),
    pageSize: z.coerce.number().int().positive().max(100).default(50),
});
export const AdminRateChangeLogListResponseSchema = z.object({
    items: z.array(AdminRateChangeLogEntrySchema),
    totalCount: z.number().int().min(0),
    page: z.number().int().positive(),
    pageSize: z.number().int().positive(),
});
//# sourceMappingURL=rate-change-log-admin.schema.js.map